import { ATTENDANCE_ABSENT_LOG } from "../../Config/ApiUrl";

export default {
    data() {
        return {
            options: {
                name: this.$t("absent_log"),
                url: ATTENDANCE_ABSENT_LOG,
                showHeader: true,
                showCount: true,
                showClearFilter: true,
                tableData: 0,
                afterRequestSuccess: ({ data }) => {
                    this.tableData = data.data.length;
                },
                columns: [
                    {
                        title: this.$t("No"),
                        type: "text",
                        key: "id",
                    },
                    {
                        title: this.$t("name"),
                        type: "custom-html",
                        key: "full_name",
                        modifier: (_value, row) => {
                            return `<a href="/employees/${row.id}/profile"
                            }">${row.full_name}</a>`;
                        },
                    },
                    {
                        title: this.$t("email"),
                        type: "text",
                        key: "email",
                    },
                ],
                filters: [
                    {
                        title: this.$t("today"),
                        type: "date",
                        key: "date",
                        initValue: new Date(),
                    },
                ],
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: "desc",
                actionType: "dropdown",
            },
        };
    },
};
